import http from './http';
import notifier from '../_utils/notifier';

const favoritesAPI = {
  getList(page) {
    return http.get('users/favorites/',{ params: { page } })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  deleteList(ids){
    return http.delete('users/favorites/',{ params: { items: ids } })
    .then(
      function(success) { return 'ok'; },
      function(error) {
        notifier.alert(gettext('При удалении товара произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },
};


export default favoritesAPI;
